import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { actions as authActions } from '../actions/auth';
import { actions as appActions } from '../actions/app';
import SidebarState from '../constants/sidebarState';
import { Button, Input } from '../styled-components/';
import localize from '../util/localizeUtils';

const LoginForm = styled.form`
  display: flex;
  width: 10rem;
  flex-direction: column;
`;

const Paper = styled.div`
  display: flex;
  align-items: center;
  box-shadow: 5px 5px 15px #888888;
  padding: 2rem;
  background-color: white;
  flex-direction: column;
`;

const LoginLabel = styled.div`
  color: grey;
  font-weight: bold;
  font-size: 14px;
  border-bottom: 1px solid #cacaca;
  margin-bottom: 1rem;
  padding-bottom: 0.75rem;
  width: 100%;
  text-align: center;
`;

const LoginContainer = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  background-image: url(images/ChyronHegoLogoBackground.png);
  background-repeat: no-repeat;
  background-position: right top;
`;

const LoginInput = styled(Input)`
  margin-bottom: 0.5rem;
  ::-webkit-input-placeholder {
    text-align: center;
  }

  :-moz-placeholder {
    text-align: center;
  }

  ::-moz-placeholder {
    text-align: center;
  }

  :-ms-input-placeholder {
    text-align: center;
  }
`;

class Login extends React.Component {
  UNSAFE_componentWillMount() {
    this.props.changeSidebarState(SidebarState.NONE);
  }

  submitForm(e) {
    e.preventDefault();
    this.props.login(e.target.userName.value, true, true);
  }

  render() {
    return (
      <LoginContainer>
        <Paper>
          <LoginLabel>
            <div>{localize('loginTitle')}</div>
          </LoginLabel>
          <LoginForm id="login-form" onSubmit={this.submitForm.bind(this)}>
            <LoginInput height="2rem" name="userName" type="text" placeholder={localize('usernamePlaceholder')} />{' '}
            <Button type="submit" id="loginButton" onClick={this.login}>
              {localize('logInButton')}
            </Button>
          </LoginForm>
        </Paper>
      </LoginContainer>
    );
  }
}

Login.defaultProps = {
  params: {
    userName: ''
  }
};

Login.propTypes = {
  login: PropTypes.func.isRequired,
  changeSidebarState: PropTypes.func.isRequired
};

const mapActionCreators = {
  login: authActions.login,
  changeSidebarState: appActions.changeSidebarState
};

export default connect(
  null,
  mapActionCreators
)(Login);



// WEBPACK FOOTER //
// ./app/components/Login.js